import { lumi } from '../lib/lumi'

interface RequestConfirmationData {
  requestId: string
  patientName: string
  bloodType: string
  hospital: string
  city: string
  state: string
  contactEmail: string
  shareToken: string
}

interface DonorMatchData {
  donorName: string
  donorEmail: string
  patientName: string
  bloodType: string
  hospital: string
  city: string
  state: string
  urgency: string
  requestId: string
  contactPhone?: string
  contactEmail?: string
}

interface DonationConfirmedData {
  requesterEmail: string
  donorName: string
  patientName: string
  bloodType: string
  hospital: string
  city: string
  state: string
  totalDonations: number
}

interface InactiveDonorData {
  donorName: string
  donorEmail: string
  lastDonationDate: string
  totalDonations: number
}

export async function sendRequestConfirmationEmail(data: RequestConfirmationData) {
  const shareUrl = `${window.location.origin}/solicitacoes`
  const trackingUrl = `${window.location.origin}/obrigado/${data.requestId}`
  
  const emailHtml = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f7f7f7; }
    .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
    .header { background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); padding: 40px 20px; text-align: center; color: white; }
    .header h1 { margin: 0; font-size: 28px; font-weight: 800; }
    .content { padding: 30px 25px; }
    .summary-box { background: #fef2f2; border-left: 4px solid #dc2626; padding: 20px; margin: 20px 0; border-radius: 8px; }
    .summary-box h3 { margin: 0 0 15px 0; color: #991b1b; font-size: 18px; }
    .summary-item { margin: 8px 0; font-size: 15px; }
    .summary-item strong { color: #111; }
    .blood-type { color: #dc2626; font-size: 20px; font-weight: 800; }
    .button { display: inline-block; background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); color: white !important; padding: 16px 32px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 16px; margin: 10px 5px; text-align: center; box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3); }
    .button:hover { background: linear-gradient(135deg, #991b1b 0%, #7f1d1d 100%); }
    .info-section { background: #eff6ff; border-radius: 8px; padding: 20px; margin: 20px 0; border: 1px solid #bfdbfe; }
    .info-section h4 { margin: 0 0 12px 0; color: #1e40af; font-size: 16px; }
    .info-section ul { margin: 8px 0; padding-left: 20px; }
    .info-section li { margin: 6px 0; color: #374151; }
    .footer { background: #f9fafb; padding: 25px; text-align: center; font-size: 13px; color: #6b7280; border-top: 1px solid #e5e7eb; }
    .footer a { color: #dc2626; text-decoration: none; font-weight: 600; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>🩸 Solicitação Criada com Sucesso!</h1>
      <p style="margin: 10px 0 0 0; font-size: 16px; opacity: 0.95;">Sua solicitação está ativa e visível para doadores</p>
    </div>
    
    <div class="content">
      <p style="font-size: 16px; margin-bottom: 20px;">
        Olá! Sua solicitação de doação de sangue foi criada com sucesso na plataforma <strong>Doe</strong>.
      </p>
      
      <div class="summary-box">
        <h3>📋 Resumo da Solicitação</h3>
        <div class="summary-item"><strong>Paciente:</strong> ${data.patientName}</div>
        <div class="summary-item"><strong>Tipo Sanguíneo:</strong> <span class="blood-type">${data.bloodType}</span></div>
        <div class="summary-item"><strong>Hospital:</strong> ${data.hospital}</div>
        <div class="summary-item"><strong>Local:</strong> ${data.city}, ${data.state}</div>
      </div>
      
      <div style="text-align: center; margin: 30px 0;">
        <a href="${trackingUrl}" class="button">Ver Minha Solicitação</a>
        <a href="${shareUrl}" class="button" style="background: linear-gradient(135deg, #059669 0%, #047857 100%);">Compartilhar Agora</a>
      </div>
      
      <div class="info-section">
        <h4>📍 Próximos Passos</h4>
        <ul>
          <li>Sua solicitação está <strong>visível para todos os doadores</strong> cadastrados na plataforma</li>
          <li><strong>Compartilhe</strong> o link nas suas redes sociais para alcançar mais pessoas</li>
          <li>Doadores compatíveis entrarão em contato pelos meios que você informou</li>
          <li>Você pode <strong>acompanhar o status</strong> da sua solicitação através do link acima</li>
        </ul>
      </div>
      
      <div class="info-section" style="background: #f0fdf4; border-color: #bbf7d0;">
        <h4 style="color: #15803d;">💡 Dica: Crie sua conta gratuita</h4>
        <p style="margin: 8px 0; color: #374151;">
          Criando uma conta você pode acompanhar sua solicitação em tempo real, receber notificações quando doadores entrarem em contato e ajudar outras pessoas também.
        </p>
        <a href="${window.location.origin}/sou-doador" class="button" style="background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%); margin-top: 10px;">Criar Conta Grátis</a>
      </div>
      
      <p style="font-size: 14px; color: #6b7280; margin-top: 25px;">
        <strong>Precisa de ajuda?</strong> Entre em contato através da plataforma ou responda este email.
      </p>
    </div>
    
    <div class="footer">
      <p style="margin: 0 0 10px 0;"><strong>Doe</strong> - Conectando vidas, salvando histórias</p>
      <p style="margin: 0;">
        <a href="${window.location.origin}">Acessar Plataforma</a> | 
        <a href="${shareUrl}">Ver Solicitações</a>
      </p>
      <p style="margin: 15px 0 0 0; font-size: 12px;">
        Você está recebendo este e-mail porque criou uma solicitação de doação de sangue.<br>
        Seus dados são protegidos pela LGPD e não são compartilhados com terceiros.
      </p>
    </div>
  </div>
</body>
</html>
  `

  const emailText = `
Solicitação Criada com Sucesso!

Olá! Sua solicitação de doação de sangue foi criada com sucesso na plataforma Doe.

Resumo da Solicitação:
- Paciente: ${data.patientName}
- Tipo Sanguíneo: ${data.bloodType}
- Hospital: ${data.hospital}
- Local: ${data.city}, ${data.state}

Próximos Passos:
1. Sua solicitação está visível para todos os doadores cadastrados
2. Compartilhe o link nas suas redes sociais: ${shareUrl}
3. Doadores compatíveis entrarão em contato pelos meios que você informou
4. Acompanhe sua solicitação: ${trackingUrl}

Dica: Crie sua conta gratuita para acompanhar sua solicitação em tempo real e receber notificações.

--
Doe - Conectando vidas, salvando histórias
${window.location.origin}
  `

  try {
    await lumi.tools.email.send({
      to: data.contactEmail,
      subject: `🩸 Solicitação de Doação Criada - ${data.patientName} (${data.bloodType})`,
      fromName: 'Doe - Rede de Doação',
      html: emailHtml,
      text: emailText,
      replyTo: 'noreply@lumi.new'
    })
    
    console.log('Email sent successfully to:', data.contactEmail)
  } catch (error) {
    console.error('Failed to send email:', error)
    throw error
  }
}

// 2. Email de Match Encontrado (para doadores compatíveis)
export async function sendDonorMatchEmail(data: DonorMatchData) {
  const requestUrl = `${window.location.origin}/solicitacoes`
  const urgencyLabel = data.urgency === 'critical' ? '🚨 CRÍTICO' : data.urgency === 'high' ? '⚠️ URGENTE' : '📍 Importante'
  
  const emailHtml = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f7f7f7; }
    .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
    .header { background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); padding: 40px 20px; text-align: center; color: white; }
    .header h1 { margin: 0; font-size: 28px; font-weight: 800; }
    .content { padding: 30px 25px; }
    .alert-box { background: #fef2f2; border: 2px solid #dc2626; padding: 20px; margin: 20px 0; border-radius: 8px; text-align: center; }
    .alert-box h2 { margin: 0 0 10px 0; color: #dc2626; font-size: 24px; }
    .patient-box { background: #eff6ff; border-left: 4px solid #3b82f6; padding: 20px; margin: 20px 0; border-radius: 8px; }
    .patient-box h3 { margin: 0 0 15px 0; color: #1e40af; font-size: 18px; }
    .info-item { margin: 8px 0; font-size: 15px; }
    .info-item strong { color: #111; }
    .blood-type { color: #dc2626; font-size: 24px; font-weight: 800; }
    .button { display: inline-block; background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); color: white !important; padding: 16px 32px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 16px; margin: 10px 5px; text-align: center; box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3); }
    .contact-box { background: #f0fdf4; border: 1px solid #86efac; padding: 15px; margin: 15px 0; border-radius: 8px; }
    .footer { background: #f9fafb; padding: 25px; text-align: center; font-size: 13px; color: #6b7280; border-top: 1px solid #e5e7eb; }
    .footer a { color: #dc2626; text-decoration: none; font-weight: 600; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>🩸 Alguém Precisa de Você!</h1>
      <p style="margin: 10px 0 0 0; font-size: 16px; opacity: 0.95;">Um paciente compatível precisa de doação</p>
    </div>
    
    <div class="content">
      <div class="alert-box">
        <h2>${urgencyLabel}</h2>
        <p style="margin: 0; font-size: 16px; color: #374151;">
          Uma pessoa com o mesmo tipo sanguíneo que você precisa de doação em <strong>${data.city}, ${data.state}</strong>
        </p>
      </div>
      
      <p style="font-size: 16px; margin: 20px 0;">
        Olá <strong>${data.donorName}</strong>! 👋
      </p>
      
      <p style="font-size: 15px; color: #374151;">
        Você está recebendo este e-mail porque seu tipo sanguíneo <strong class="blood-type">${data.bloodType}</strong> é compatível com um pedido urgente de doação.
      </p>
      
      <div class="patient-box">
        <h3>📋 Informações do Pedido</h3>
        <div class="info-item"><strong>Paciente:</strong> ${data.patientName}</div>
        <div class="info-item"><strong>Tipo Sanguíneo:</strong> <span class="blood-type">${data.bloodType}</span></div>
        <div class="info-item"><strong>Hospital:</strong> ${data.hospital}</div>
        <div class="info-item"><strong>Local:</strong> ${data.city}, ${data.state}</div>
        <div class="info-item"><strong>Urgência:</strong> ${urgencyLabel}</div>
      </div>
      
      ${data.contactPhone || data.contactEmail ? `
      <div class="contact-box">
        <p style="margin: 0 0 10px 0; font-weight: 600; color: #15803d;">📞 Contato Direto:</p>
        ${data.contactPhone ? `<p style="margin: 5px 0;"><strong>WhatsApp:</strong> ${data.contactPhone}</p>` : ''}
        ${data.contactEmail ? `<p style="margin: 5px 0;"><strong>E-mail:</strong> ${data.contactEmail}</p>` : ''}
      </div>
      ` : ''}
      
      <div style="text-align: center; margin: 30px 0;">
        <a href="${requestUrl}" class="button">Ver Detalhes do Pedido</a>
      </div>
      
      <div style="background: #fef3c7; border-left: 4px solid #f59e0b; padding: 15px; margin: 20px 0; border-radius: 8px;">
        <p style="margin: 0; font-size: 14px; color: #92400e;">
          <strong>💡 Você não é obrigado a doar!</strong> Este é apenas um aviso de compatibilidade. Se puder ajudar, será incrível. Se não puder agora, tudo bem – sua saúde vem primeiro.
        </p>
      </div>
      
      <p style="font-size: 14px; color: #6b7280; margin-top: 25px;">
        Cada doação pode salvar até <strong>4 vidas</strong>. Você já faz parte dessa rede de solidariedade. ❤️
      </p>
    </div>
    
    <div class="footer">
      <p style="margin: 0 0 10px 0;"><strong>Doe</strong> - Conectando vidas, salvando histórias</p>
      <p style="margin: 0;">
        <a href="${window.location.origin}">Acessar Plataforma</a> | 
        <a href="${requestUrl}">Ver Todos os Pedidos</a>
      </p>
      <p style="margin: 15px 0 0 0; font-size: 12px;">
        Você está recebendo este e-mail porque seu perfil é compatível com um pedido de doação.<br>
        Para parar de receber notificações, acesse seu perfil e desative as notificações.
      </p>
    </div>
  </div>
</body>
</html>
  `

  const emailText = `
🩸 Alguém Precisa de Você!

${urgencyLabel}

Olá ${data.donorName}!

Uma pessoa com o mesmo tipo sanguíneo que você precisa de doação em ${data.city}, ${data.state}.

Informações do Pedido:
- Paciente: ${data.patientName}
- Tipo Sanguíneo: ${data.bloodType}
- Hospital: ${data.hospital}
- Local: ${data.city}, ${data.state}
- Urgência: ${urgencyLabel}

${data.contactPhone ? `WhatsApp: ${data.contactPhone}` : ''}
${data.contactEmail ? `E-mail: ${data.contactEmail}` : ''}

Ver detalhes: ${requestUrl}

💡 Você não é obrigado a doar! Este é apenas um aviso de compatibilidade.

Cada doação pode salvar até 4 vidas. Você já faz parte dessa rede de solidariedade. ❤️

--
Doe - Conectando vidas, salvando histórias
${window.location.origin}
  `

  try {
    await lumi.tools.email.send({
      to: data.donorEmail,
      subject: `🩸 Alguém precisa do seu tipo sanguíneo em ${data.city}`,
      fromName: 'Doe - Rede de Doação',
      html: emailHtml,
      text: emailText,
      replyTo: 'noreply@lumi.new'
    })
    
    console.log('Match email sent successfully to:', data.donorEmail)
  } catch (error) {
    console.error('Failed to send match email:', error)
    throw error
  }
}

// 3. Email de Doação Confirmada (para solicitante)
export async function sendDonationConfirmedEmail(data: DonationConfirmedData) {
  const requestsUrl = `${window.location.origin}/solicitacoes`
  
  const emailHtml = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f7f7f7; }
    .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
    .header { background: linear-gradient(135deg, #059669 0%, #047857 100%); padding: 40px 20px; text-align: center; color: white; }
    .header h1 { margin: 0; font-size: 32px; font-weight: 800; }
    .content { padding: 30px 25px; }
    .celebration-box { background: #f0fdf4; border: 2px solid #10b981; padding: 25px; margin: 20px 0; border-radius: 12px; text-align: center; }
    .celebration-box h2 { margin: 0 0 15px 0; color: #047857; font-size: 24px; }
    .stats-box { background: #eff6ff; padding: 20px; margin: 20px 0; border-radius: 8px; text-align: center; }
    .stat-item { display: inline-block; margin: 10px 20px; }
    .stat-number { font-size: 36px; font-weight: 800; color: #dc2626; display: block; }
    .stat-label { font-size: 14px; color: #6b7280; }
    .button { display: inline-block; background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); color: white !important; padding: 16px 32px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 16px; margin: 10px 5px; text-align: center; box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3); }
    .footer { background: #f9fafb; padding: 25px; text-align: center; font-size: 13px; color: #6b7280; border-top: 1px solid #e5e7eb; }
    .footer a { color: #dc2626; text-decoration: none; font-weight: 600; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>🎉 Boa Notícia!</h1>
      <p style="margin: 10px 0 0 0; font-size: 18px; opacity: 0.95;">Alguém confirmou que doou para ${data.patientName}</p>
    </div>
    
    <div class="content">
      <div class="celebration-box">
        <h2>❤️ ${data.donorName} Confirmou a Doação!</h2>
        <p style="margin: 0; font-size: 16px; color: #374151;">
          ${data.donorName} confirmou que realizou a doação de <strong>${data.bloodType}</strong> para <strong>${data.patientName}</strong> no ${data.hospital}.
        </p>
      </div>
      
      <p style="font-size: 16px; margin: 20px 0; text-align: center;">
        Isso é incrível! A solidariedade aconteceu. 🩸
      </p>
      
      <div class="stats-box">
        <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 600; color: #1e40af;">
          📊 Impacto dessa doação:
        </p>
        <div class="stat-item">
          <span class="stat-number">4</span>
          <span class="stat-label">Vidas Salvas</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">${data.totalDonations}</span>
          <span class="stat-label">Doações de ${data.donorName}</span>
        </div>
      </div>
      
      <p style="font-size: 15px; color: #374151; text-align: center; margin: 25px 0;">
        Obrigado por usar a plataforma <strong>Doe</strong> para conectar vidas. Você fez a diferença! 🙏
      </p>
      
      <div style="background: #fef3c7; border-left: 4px solid #f59e0b; padding: 15px; margin: 20px 0; border-radius: 8px;">
        <p style="margin: 0; font-size: 14px; color: #92400e;">
          <strong>💡 Compartilhe sua história!</strong> Conte para amigos e familiares como a plataforma Doe ajudou você. Juntos, podemos salvar mais vidas.
        </p>
      </div>
      
      <div style="text-align: center; margin: 30px 0;">
        <a href="${requestsUrl}" class="button">Ver Outros Pedidos</a>
      </div>
    </div>
    
    <div class="footer">
      <p style="margin: 0 0 10px 0;"><strong>Doe</strong> - Conectando vidas, salvando histórias</p>
      <p style="margin: 0;">
        <a href="${window.location.origin}">Acessar Plataforma</a> | 
        <a href="${requestsUrl}">Ver Solicitações</a>
      </p>
      <p style="margin: 15px 0 0 0; font-size: 12px;">
        Você está recebendo este e-mail porque criou uma solicitação de doação de sangue.
      </p>
    </div>
  </div>
</body>
</html>
  `

  const emailText = `
🎉 Boa Notícia!

Alguém confirmou que doou para ${data.patientName}

❤️ ${data.donorName} Confirmou a Doação!

${data.donorName} confirmou que realizou a doação de ${data.bloodType} para ${data.patientName} no ${data.hospital}.

Isso é incrível! A solidariedade aconteceu. 🩸

📊 Impacto dessa doação:
- 4 Vidas Salvas
- ${data.totalDonations} Doações de ${data.donorName}

Obrigado por usar a plataforma Doe para conectar vidas. Você fez a diferença! 🙏

--
Doe - Conectando vidas, salvando histórias
${window.location.origin}
  `

  try {
    await lumi.tools.email.send({
      to: data.requesterEmail,
      subject: `🎉 ${data.donorName} confirmou que doou para ${data.patientName}`,
      fromName: 'Doe - Rede de Doação',
      html: emailHtml,
      text: emailText,
      replyTo: 'noreply@lumi.new'
    })
    
    console.log('Donation confirmed email sent successfully to:', data.requesterEmail)
  } catch (error) {
    console.error('Failed to send donation confirmed email:', error)
    throw error
  }
}

// 4. Email de Lembrete para Doador Inativo (90 dias)
export async function sendInactiveDonorReminderEmail(data: InactiveDonorData) {
  const requestsUrl = `${window.location.origin}/solicitacoes`
  const profileUrl = `${window.location.origin}/sou-doador`
  
  const emailHtml = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 0; background-color: #f7f7f7; }
    .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
    .header { background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%); padding: 40px 20px; text-align: center; color: white; }
    .header h1 { margin: 0; font-size: 28px; font-weight: 800; }
    .content { padding: 30px 25px; }
    .miss-you-box { background: #fef3c7; border: 2px solid #f59e0b; padding: 25px; margin: 20px 0; border-radius: 12px; text-align: center; }
    .miss-you-box h2 { margin: 0 0 15px 0; color: #92400e; font-size: 24px; }
    .stats-box { background: #eff6ff; padding: 20px; margin: 20px 0; border-radius: 8px; }
    .stat-item { margin: 10px 0; font-size: 15px; }
    .stat-number { font-size: 24px; font-weight: 800; color: #dc2626; }
    .button { display: inline-block; background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); color: white !important; padding: 16px 32px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 16px; margin: 10px 5px; text-align: center; box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3); }
    .footer { background: #f9fafb; padding: 25px; text-align: center; font-size: 13px; color: #6b7280; border-top: 1px solid #e5e7eb; }
    .footer a { color: #dc2626; text-decoration: none; font-weight: 600; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>💜 Sentimos Sua Falta!</h1>
      <p style="margin: 10px 0 0 0; font-size: 16px; opacity: 0.95;">Alguém pode precisar de você agora</p>
    </div>
    
    <div class="content">
      <div class="miss-you-box">
        <h2>👋 Olá, ${data.donorName}!</h2>
        <p style="margin: 0; font-size: 16px; color: #374151;">
          Faz um tempo que você não aparece por aqui. Está tudo bem com você?
        </p>
      </div>
      
      <p style="font-size: 15px; color: #374151; margin: 20px 0;">
        Sua última doação foi em <strong>${new Date(data.lastDonationDate).toLocaleDateString('pt-BR')}</strong>, há mais de 90 dias. 
      </p>
      
      <div class="stats-box">
        <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 600; color: #1e40af;">
          🏆 Seu Histórico de Herói:
        </p>
        <div class="stat-item">
          <span class="stat-number">${data.totalDonations}</span> doações realizadas
        </div>
        <div class="stat-item">
          Até <span class="stat-number">${data.totalDonations * 4}</span> vidas salvas graças a você! 🩸
        </div>
      </div>
      
      <p style="font-size: 15px; color: #374151; text-align: center; margin: 25px 0;">
        A comunidade precisa de pessoas como você. Que tal voltar a fazer a diferença?
      </p>
      
      <div style="background: #fef2f2; border-left: 4px solid #dc2626; padding: 15px; margin: 20px 0; border-radius: 8px;">
        <p style="margin: 0; font-size: 14px; color: #991b1b;">
          <strong>🩸 Você sabia?</strong> No Brasil, mais de 10 mil pessoas precisam de transfusão de sangue todos os dias. Seu gesto simples pode salvar até 4 vidas.
        </p>
      </div>
      
      <div style="text-align: center; margin: 30px 0;">
        <a href="${requestsUrl}" class="button">Ver Quem Precisa Agora</a>
        <a href="${profileUrl}" class="button" style="background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);">Atualizar Meu Perfil</a>
      </div>
      
      <p style="font-size: 13px; color: #6b7280; text-align: center; margin-top: 25px;">
        Se não puder doar agora, tudo bem! Sua saúde vem primeiro. Mas ficaremos felizes em te ver de volta quando for possível. ❤️
      </p>
    </div>
    
    <div class="footer">
      <p style="margin: 0 0 10px 0;"><strong>Doe</strong> - Conectando vidas, salvando histórias</p>
      <p style="margin: 0;">
        <a href="${window.location.origin}">Acessar Plataforma</a> | 
        <a href="${requestsUrl}">Ver Solicitações</a>
      </p>
      <p style="margin: 15px 0 0 0; font-size: 12px;">
        Você está recebendo este e-mail porque é um doador cadastrado na plataforma Doe.<br>
        Para parar de receber lembretes, acesse seu perfil e desative as notificações.
      </p>
    </div>
  </div>
</body>
</html>
  `

  const emailText = `
💜 Sentimos Sua Falta!

Olá, ${data.donorName}!

Faz um tempo que você não aparece por aqui. Está tudo bem com você?

Sua última doação foi em ${new Date(data.lastDonationDate).toLocaleDateString('pt-BR')}, há mais de 90 dias.

🏆 Seu Histórico de Herói:
- ${data.totalDonations} doações realizadas
- Até ${data.totalDonations * 4} vidas salvas graças a você! 🩸

A comunidade precisa de pessoas como você. Que tal voltar a fazer a diferença?

🩸 Você sabia? No Brasil, mais de 10 mil pessoas precisam de transfusão de sangue todos os dias. Seu gesto simples pode salvar até 4 vidas.

Ver quem precisa agora: ${requestsUrl}
Atualizar meu perfil: ${profileUrl}

Se não puder doar agora, tudo bem! Sua saúde vem primeiro. Mas ficaremos felizes em te ver de volta quando for possível. ❤️

--
Doe - Conectando vidas, salvando histórias
${window.location.origin}
  `

  try {
    await lumi.tools.email.send({
      to: data.donorEmail,
      subject: '💜 Sentimos sua falta! Alguém pode precisar de você',
      fromName: 'Doe - Rede de Doação',
      html: emailHtml,
      text: emailText,
      replyTo: 'noreply@lumi.new'
    })
    
    console.log('Inactive donor reminder email sent successfully to:', data.donorEmail)
  } catch (error) {
    console.error('Failed to send inactive donor reminder email:', error)
    throw error
  }
}
